import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'components/Modal';

import Confirmation from './Confirmation';
import Form from './Form';

const PdpProductUpdatesForm = ({
  currentProduct,
  currentVariant,
  isOpen,
  closeModal,
  modalSettings,
  hasSignedUpForProductUpdates,
  isSigningUpForProductUpdates,
  signUpForProductUpdates,
  signUpForNewsletter,
}) =>
  currentProduct && currentVariant ? (
    <Modal
      isOpen={isOpen}
      portalClassName="PdpProductUpdatesForm"
      onRequestClose={closeModal}
      {...modalSettings}
    >
      <div className="PdpProductUpdatesForm__body">
        {!hasSignedUpForProductUpdates ? (
          <Form
            product={currentProduct}
            variant={currentVariant}
            isLoading={isSigningUpForProductUpdates}
            signUpForProductUpdates={signUpForProductUpdates}
            signUpForNewsletter={signUpForNewsletter}
          />
        ) : (
          <Confirmation />
        )}
      </div>
      )
    </Modal>
  ) : null;

PdpProductUpdatesForm.propTypes = {
  currentProduct: PropTypes.shape({}).isRequired,
  currentVariant: PropTypes.shape({}),
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  modalSettings: PropTypes.shape({}),
  hasSignedUpForProductUpdates: PropTypes.bool.isRequired,
  isSigningUpForProductUpdates: PropTypes.bool.isRequired,
  signUpForProductUpdates: PropTypes.func.isRequired,
  signUpForNewsletter: PropTypes.func.isRequired,
};

PdpProductUpdatesForm.defaultProps = {
  isOpen: false,
  modalSettings: {},
  currentVariant: null,
};

export default PdpProductUpdatesForm;
